import { createContext, useReducer, useEffect } from 'react';
import cartReducer from '../reducers/CartReducer';
import initialState from '../state/InitialState';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchProducts } from '../services/ProductService';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const navigate = useNavigate();

  const [state, dispatch] = useReducer(cartReducer, initialState);

  // Fetch products on mount
  useEffect(() => {
    const loadProducts = async () => {
      try {
        const products = await fetchProducts();
        dispatch({ type: 'SET_PRODUCTS', payload: products });
      } catch (err) {
        console.error('Error fetching products:', err);
      }
    };

    loadProducts();
  }, []);

  const addToCart = (product) => {
    dispatch({ type: 'ADD_TO_CART', payload: product });
  };

  const handleQuantityChange = (id, value) => {
    if (value < 0) return;
    dispatch({ type: 'UPDATE_ITEM_QUANTITY', payload: { id, quantity: value } });
  };

  const clearCart = () => {
    dispatch({ type: 'CLEAR_CART' });
  };

  const enviarPedido = async (e, formData) => {
    e.preventDefault();

    const productos = state.cart.map(item => ({
      idproducto: item.id,
      cantidad: item.cantidadEnCarrito,
    }));

    const payload = {
      productos,
      ...formData,
    };

    try {
      const response = await fetch('https://marketluz.com/laravel8/public/api/procesarCarritoItems', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Pedido enviado:', result);
        toast.success('¡Pedido enviado con éxito!');
        dispatch({ type: 'CLEAR_CART' });
        navigate('/gracias', { state: formData });
      } else {
        toast.error('Error al enviar el pedido.');
      }
    } catch (error) {
      console.error('Error de conexión:', error);
      toast.error('Error de conexión. Por favor, intenta más tarde.');
    }
  };

  return (
    <CartContext.Provider value={{
      state,
      dispatch,
      addToCart,
      handleQuantityChange,
      clearCart,
      enviarPedido,
    }}>
      {children}
    </CartContext.Provider>
  );
};
